import { render, staticRenderFns } from "./BaseInformationCard.vue?vue&type=template&id=6ad72f7c&scoped=true"
import script from "./BaseInformationCard.vue?vue&type=script&lang=js"
export * from "./BaseInformationCard.vue?vue&type=script&lang=js"
import style0 from "./BaseInformationCard.vue?vue&type=style&index=0&id=6ad72f7c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad72f7c",
  null
  
)

export default component.exports